import agendaApiConfig from "./agendaApiConfig";

const AgendamientoInconcluso = {
    async save(body) {
        return await agendaApiConfig.post("/inconcluso", body);
    },
    async existPatient(rut) {
        return await agendaApiConfig.get(`/paciente/existe`, {
            params: { rut },
        });
    }
}

export default AgendamientoInconcluso;